;
export const generateKeyNames = (keyAndPayloadNames) => {
    return {
        START: keyAndPayloadNames.keyStart + "_FETCH_START",
        SUCCESS: keyAndPayloadNames.keyStart + "_FETCH_SUCCESS",
        FAILURE: keyAndPayloadNames.keyStart + "_FETCH_FAILURE"
    };
};
